export default 'An error occurred. Please try again later'
